import { FC } from 'react';

import { useGiftStoreItemCountForAdmin } from '@shared/api/giftItem/giftItem.hook';
import { BugoBrand, BugoBrandData } from '@shared/api/bugoBrand/bugoBrand.interface';
import { isGiftBrandLive } from '@shared/utils/giftPilot.util';

interface Props {
  bugoBrand: BugoBrand | BugoBrandData;
  className?: string;
}

//* 실행 전 상조에 스토어 판매상품이 0개면 경고 — 파일럿 상가 상주는 알림톡 버튼을 눌러도 빈 스토어를 본다
//* 전체 실행 상조는 파일럿이 의미 없으므로 조회도 하지 않는다
export const GiftPilotStoreWarning: FC<Props> = function GiftPilotStoreWarning({
  bugoBrand,
  className = '',
}: Props) {
  const live = isGiftBrandLive(bugoBrand);
  const count = useGiftStoreItemCountForAdmin(bugoBrand._id, !live);
  if (live || count !== 0) return null;
  return (
    <p className={`text-12 font-medium text-red-500 ${className}`}>
      판매상품 0개 · 파일럿 상가 스토어 빈 화면
    </p>
  );
};
